/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Telemedicine_Landing_TitleInputs */

const en_service_telemedicine_landing_title = /** @type {(inputs: Service_Telemedicine_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Care From Anywhere`)
};

const fr_service_telemedicine_landing_title = /** @type {(inputs: Service_Telemedicine_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des soins de partout`)
};

/**
* | output |
* | --- |
* | "Care From Anywhere" |
*
* @param {Service_Telemedicine_Landing_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_telemedicine_landing_title = /** @type {((inputs?: Service_Telemedicine_Landing_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Telemedicine_Landing_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_telemedicine_landing_title(inputs)
	return fr_service_telemedicine_landing_title(inputs)
});